// src/wizard/WizardShell.tsx
import React from "react";
import Button from "../components/ui/Button";

type Props = {
  title: string;
  subtitle?: string;
  children: React.ReactNode;
  canGoBack: boolean;
  canGoNext: boolean;
  primaryLabel: string;
  onBack: () => void;
  onNext: () => void;
  footerHint?: string;
};

export default function WizardShell({
  title,
  subtitle,
  children,
  canGoBack,
  canGoNext,
  primaryLabel,
  onBack,
  onNext,
  footerHint,
}: Props) {
  return (
    <div className="space-y-4">
      <header className="rounded-xl bg-white p-4 ring-1 ring-slate-200">
        <h1 className="text-xl font-bold">{title}</h1>
        {subtitle ? (
          <p className="mt-1 text-sm text-slate-600">{subtitle}</p>
        ) : null}
      </header>

      <section className="rounded-xl bg-white p-4 ring-1 ring-slate-200">
        {children}
      </section>

      <footer className="rounded-xl bg-white p-4 ring-1 ring-slate-200">
        {footerHint && canGoNext ? (
          <p className="mb-3 text-xs text-slate-600">{footerHint}</p>
        ) : null}
        <div className="flex items-center justify-between gap-3">
          <Button
            type="button"
            variant="secondary"
            onClick={onBack}
            disabled={!canGoBack}
            className={canGoNext ? "w-1/2" : "w-full"}
          >
            Back
          </Button>
          {canGoNext && (
            <Button type="button" onClick={onNext} className="w-1/2">
              {primaryLabel}
            </Button>
          )}
        </div>
      </footer>
    </div>
  );
}
